iScreenWizard.directive('menuLink', function () {
	return {
		scope: {
			section: '=',
			toggleSidebar: '=togglesidebar'
		},
		templateUrl: 'partials/menu-link',
		link: function ($scope, $element) {
			var controller = $scope.$parent;

			$scope.userService = controller.userService;

			$scope.focusSection = function () {
				// set flag to be used later when
				// $locationChangeSuccess calls openPage()
				controller.autoFocusContent = true;
			};
		}
	};
});